import loadable from '@loadable/component';

export const CreditsListContainerLoadable = loadable(
  () => import('./CreditsListContainer'),
  {
    resolveComponent: (module) => module.CreditsListContainer,
  },
);
